import { TextArea } from "@jammable/ui-components/Forms";
import { Button, toast } from "@jammable/ui-core";
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

import { requireIdToken } from "../../utils/firebaseAuth";
import { useRouter } from "next/router";
import { Spinner } from "@jammable/ui-components/Loader";

// receiverProfile is the receiver's Mongo user _id (the profile page does not
// have their Firebase uid).
const SendMessageModal = ({ receiverProfile }) => {
  const router = useRouter();
  const validationSchema = Yup.object().shape({
    message: Yup.string().required("Message is required"),
  });
  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const token = await requireIdToken();
        await axios
          .post(
            "/api/message/sendMessage",
            {
              message: values.message,
              profile: receiverProfile,
            },
            {
              headers: { Authorization: token },
            },
          )
          .then((res) => {
            router.push(`/messages/${res.data.conversation._id}`);
          });
        console.log("Message submitted:", values.message);
        // You can add your logic to handle successful submission here
      } catch (error) {
        console.error("Error sending message:", error);
        toast.error("Error sending message... please try again!");
        // Handle error here
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div>
      <div className="tw-text-xl tw-font-black tw-w-full tw-text-center">
        Send Message
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div>
          <TextArea
            className="tw-w-full tw-mt-2"
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Type your message here..."
          />
          {formik.touched.message && formik.errors.message && (
            <div className="tw-text-red-500 tw-text-sm tw-mt-1">
              {formik.errors.message}
            </div>
          )}
        </div>
        <Button
          type="submit"
          className="tw-w-full tw-rounded-full tw-mt-2"
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? (
            <Spinner size={4} className="tw-border-white tw-border-3" />
          ) : (
            "Send"
          )}
        </Button>
      </form>
    </div>
  );
};

export default SendMessageModal;
